export default "__VITE_ASSET__CaQG0YnW__"